import { useState } from 'react';
import ScaleLoader from 'react-spinners/ScaleLoader';

import Layout from 'src/components/layouts';
import { SHOW_COMMEMORATE } from 'src/constants';

const TrainingPage = () => {
  const [loading, setLoading] = useState(true);

  return (
    <Layout>
      <div style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
        {loading ? (
          <div className='my-5 text-center'>
            <ScaleLoader height={24} width={2} radius={2} margin={4} color={'#02d667'} />
          </div>
        ) : null}
        <iframe
          src='https://docs.google.com/forms/d/e/1FAIpQLSdAzEtecwi5Y9Hi3Q23irjiG0_q4l4Gzom9y5feLghi4sL7Ig/viewform'
          width='100%'
          height='700'
          onLoad={() => setLoading(false)}
          frameBorder='0'
          marginHeight='0'
          marginWidth='0'
        />
      </div>
    </Layout>
  );
};

export default TrainingPage;
